// register-header v1: 注册页面头部组件
// 从 RegisterPage.js 中提取的头部区域

import React from 'react';

/**
 * RegisterHeader 组件 - 注册页面头部
 * @returns {JSX.Element} 头部组件
 */
const RegisterHeader = () => {
  return (
    <div className='text-center mb-4'>
      <img
        src={`${process.env.PUBLIC_URL || ''}/TAG_Logo.png`}
        alt='TAG Logo'
        className='h-12 w-auto mx-auto mb-3'
        onError={e => {
          console.error('Logo failed to load:', e.target.src);
          e.target.style.display = 'none';
        }}
      />
      <p className='text-sm font-light text-white mb-8 whitespace-nowrap'>
        Sign up with your email to join TAG
      </p>
    </div>
  );
};

export default RegisterHeader;
